// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/Directory.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Container Styling */
.faculty-detail1 {
  padding: 20px;
  background-color: #f9f9f9; /* Light gray for readability */
  color: #ffffff; /* Darker text for contrast */
  font-family: 'Raleway', sans-serif;
  margin: 0 auto; /* Center the content */
  max-width: 1200px; /* Width restriction */
  font-size: 0;

}

/* Header Section */
.faculty-detail header {
  background-image: linear-gradient(rgb(17, 17, 240), rgba(100, 127, 49, 0.35)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: flex;
  flex-direction: column;
  justify-content: flex-end; /* Aligns content to bottom */
  text-align: end; /* Right-aligned text */
  
  background-size: cover; /* Covers the area */
  background-position: center; /* Centers the background image */
  height: 400px; /* Adjust height for visibility */
  padding: 10px;
 
  color: #844a4a; /* White text color */
}

/* Faculty Profile Container */
.faculty-profile-container2 {
  display: flex;
  gap: 1px; /* Space between left and right columns */
  margin-top: 20px; /* Separation from header */
  border: 0;
  border-color: #999baa;
  align-items: flex-start; /* Top alignment for content */
}

/* Left Column Styling */
.brief-details1 {
  flex: 1 1; /* Left column width */
  background-color: #1b070700; /* White background for contrast */
  padding: 10px;
  border: 0px solid #ddd; /* Subtle border */
  border-radius: 3px; /* Rounded corners */
  box-shadow: 0 5px 7px rgba(255, 255, 255, 0.1); /* Shadow effect */
}

/* Image Styling */
.faculty-image1 {
  width: 190px;
  height: 190px;
  object-fit: cover; /* Maintain aspect ratio */
  border-radius: 50%; /* Circular shape */
  border: 0px solid #007bff; /* Blue border */
  margin-right: 20px; /* Space beside the image */
}

/* Text and Titles */
.faculty-name1 {
  font-size: 19px; /* Slightly larger for emphasis */
  font-family: 'Raleway', sans-serif;
  
  font-weight: bold; /* Bold for prominence */
  color: #211c4a; /* Darker text */
  
}

.faculty-designation1,
.faculty-department1 {
  font-family: 'Raleway', sans-serif;
  font-size: 13px; /* Font size for roles and departments */
  color: #4b2a2a; /* Subtle gray */
  margin: 0px 0; /* Space between text */
}

/* Bottom Section in Left Column */
.brief-bottom1 {
  margin-top: 25px; /* Space above the bottom section */
}

/* Contact Info */
.contact-info1 {
  display: flex; /* Align icon and text */
  align-items: center; /* Center vertically */
  font-family: 'Raleway', sans-serif;
  margin: 10px 0; /* Space between items */
  padding: 10px 0px; /* Inner spacing */
  font-size: 16px; /* Base font size */
  color: #4a4a4a; /* Default text color */
}

.contact-info1 i {
  margin-right: 10px; /* Space between icon and text */
  
  font-size: 18px; /* Icon size */
  color: #007bff; /* Icon color */
}

.contact-info1 .contact-text1 {
  font-family: 'Raleway', sans-serif;
  font-size: 14px; /* Text font size */
  line-height: 0; /* Line spacing */
  color: #432020; /* Text color */
}

.contact-info1 .contact-text1 strong {
  font-family: 'Raleway', sans-serif;
  color: #583a3a; /* Bold text color */
  font-size: 13px; /* Text font size */

  font-weight: bold; /* Ensure boldness */
}
.contact-text1 a:hover {
  text-decoration: underline; /* Underline on hover */
}

/* Links for Profiles */
.profile-links1 {
  margin-top: 10px; /* Space above the links */
}

.profile-links1 a {
  color: #007bff; /* Blue for links */
  font-size: 14px; /* Font size */
  font-family: 'Raleway', sans-serif;
  text-decoration: none; /* No underline */
}

.profile-links1 a:hover {
  text-decoration: underline; /* Underline on hover */
}

/* Right Column Styling */
.details-section1 {

  flex: 2 1; /* Right column takes more space */
  background-color: #e2e6ea; /* Subtle gray background */
  padding: 20px;
  border: 0px solid #ddd; /* Subtle border */
  border-radius: 1px; /* Rounded corners */
}

/* Updated Text Elements in Right Column */
.details-section1 p {
  margin: 10px 0; /* Vertical spacing */
  font-size: 15px; /* General font size */
  font-weight: 100px;
  font-family: 'Raleway', sans-serif;
  line-height: 1.4; /* Line spacing for readability */
  color: #142535; /* Slightly darker text */
  white-space: pre-wrap; /* Preserve spaces and line breaks */
}

/* Heading Styling */
.details-section1 h3 {
  font-weight: bold;
  font-size: 14px; /* Larger font for headings */
  font-family: 'Raleway', sans-serif;
  color:#163046; /* Blue headings */
  margin-bottom: 10px; /* Space below headings */
}

/* Horizontal Line Styling */
.details-section1 hr {
  border: 0;
  height: 1px;
  background-color: #fbfbfb; /* Light gray line */
  margin: 15px 0; /* Space around lines */
}

.publication-item {
  display: flex;
  font-size: 14px; /* Larger font for headings */
  font-family: 'Raleway', sans-serif;
  color:#071a29; /* Blue headings */
  justify-content: space-between;
  align-items: center;
  
  padding: 5px;
}


/* Responsive Adjustments */
@media screen and (max-width: 768px) {
  .faculty-profile-container2 {
      flex-direction: column; /* Stack columns vertically */
  }

  .brief-details1,
  .details-section1 {
      max-width: 100%; /* Full width for smaller screens */
      flex: unset; /* Remove flex properties */
  }

  .faculty-image {
      margin-right: 0; /* Remove space for smaller screens */
      margin-bottom: 15px; /* Add spacing below */
  }
}

/* Additional Small Screen Adjustments */
@media screen and (max-width: 480px) {
  .faculty-image {
      width: 120px; /* Reduce size for very small screens */
      height: 120px;
  }

  .faculty-name1 {
      font-size: 18px; /* Adjust font size */
  }

  .faculty-designation1,
  .faculty-department1 {
      font-size: 14px; /* Adjust font size */
  }

  .contact-info1 {
      flex-direction: column; /* Stack contact info vertically */
      align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FacultyProfileDetails.css"],"names":[],"mappings":"AAIA,8BAA8B;AAC9B;EACE,aAAa;EACb,yBAAyB,EAAE,+BAA+B;EAC1D,cAAc,EAAE,6BAA6B;EAC7C,kCAAkC;EAClC,cAAc,EAAE,uBAAuB;EACvC,iBAAiB,EAAE,sBAAsB;EACzC,YAAY;;AAEd;;AAEA,mBAAmB;AACnB;EACE,sHAA4G;EAC5G,aAAa;EACb,sBAAsB;EACtB,yBAAyB,EAAE,6BAA6B;EACxD,eAAe,EAAE,uBAAuB;;EAExC,sBAAsB,EAAE,oBAAoB;EAC5C,2BAA2B,EAAE,iCAAiC;EAC9D,aAAa,EAAE,iCAAiC;EAChD,aAAa;;EAEb,cAAc,EAAE,qBAAqB;AACvC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,QAAQ,EAAE,yCAAyC;EACnD,gBAAgB,EAAE,2BAA2B;EAC7C,SAAS;EACT,qBAAqB;EACrB,uBAAuB,EAAE,8BAA8B;AACzD;;AAEA,wBAAwB;AACxB;EACE,SAAO,EAAE,sBAAsB;EAC/B,2BAA2B,EAAE,kCAAkC;EAC/D,aAAa;EACb,sBAAsB,EAAE,kBAAkB;EAC1C,kBAAkB,EAAE,oBAAoB;EACxC,8CAA8C,EAAE,kBAAkB;AACpE;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB,EAAE,0BAA0B;EAC7C,kBAAkB,EAAE,mBAAmB;EACvC,yBAAyB,EAAE,gBAAgB;EAC3C,kBAAkB,EAAE,2BAA2B;AACjD;;AAEA,oBAAoB;AACpB;EACE,eAAe,EAAE,iCAAiC;EAClD,kCAAkC;;EAElC,iBAAiB,EAAE,wBAAwB;EAC3C,cAAc,EAAE,gBAAgB;;AAElC;;AAEA;;EAEE,kCAAkC;EAClC,eAAe,EAAE,wCAAwC;EACzD,cAAc,EAAE,gBAAgB;EAChC,aAAa,EAAE,uBAAuB;AACxC;;AAEA,kCAAkC;AAClC;EACE,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA,iBAAiB;AACjB;EACE,aAAa,EAAE,wBAAwB;EACvC,mBAAmB,EAAE,sBAAsB;EAC3C,kCAAkC;EAClC,cAAc,EAAE,wBAAwB;EACxC,iBAAiB,EAAE,kBAAkB;EACrC,eAAe,EAAE,mBAAmB;EACpC,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,kBAAkB,EAAE,gCAAgC;;EAEpD,eAAe,EAAE,cAAc;EAC/B,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,kCAAkC;EAClC,eAAe,EAAE,mBAAmB;EACpC,cAAc,EAAE,iBAAiB;EACjC,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,kCAAkC;EAClC,cAAc,EAAE,oBAAoB;EACpC,eAAe,EAAE,mBAAmB;;EAEpC,iBAAiB,EAAE,oBAAoB;AACzC;AACA;EACE,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA,uBAAuB;AACvB;EACE,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,eAAe,EAAE,cAAc;EAC/B,kCAAkC;EAClC,qBAAqB,EAAE,iBAAiB;AAC1C;;AAEA;EACE,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA,yBAAyB;AACzB;;EAEE,SAAO,EAAE,kCAAkC;EAC3C,yBAAyB,EAAE,2BAA2B;EACtD,aAAa;EACb,sBAAsB,EAAE,kBAAkB;EAC1C,kBAAkB,EAAE,oBAAoB;AAC1C;;AAEA,0CAA0C;AAC1C;EACE,cAAc,EAAE,qBAAqB;EACrC,eAAe,EAAE,sBAAsB;EACvC,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB,EAAE,iCAAiC;EACnD,cAAc,EAAE,yBAAyB;EACzC,qBAAqB,EAAE,oCAAoC;AAC7D;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,eAAe,EAAE,6BAA6B;EAC9C,kCAAkC;EAClC,aAAa,EAAE,kBAAkB;EACjC,mBAAmB,EAAE,yBAAyB;AAChD;;AAEA,4BAA4B;AAC5B;EACE,SAAS;EACT,WAAW;EACX,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc,EAAE,uBAAuB;AACzC;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,6BAA6B;EAC9C,kCAAkC;EAClC,aAAa,EAAE,kBAAkB;EACjC,8BAA8B;EAC9B,mBAAmB;;EAEnB,YAAY;AACd;;;AAGA,2BAA2B;AAC3B;EACE;MACI,sBAAsB,EAAE,6BAA6B;EACzD;;EAEA;;MAEI,eAAe,EAAE,mCAAmC;MACpD,WAAW,EAAE,2BAA2B;EAC5C;;EAEA;MACI,eAAe,EAAE,qCAAqC;MACtD,mBAAmB,EAAE,sBAAsB;EAC/C;AACF;;AAEA,wCAAwC;AACxC;EACE;MACI,YAAY,EAAE,uCAAuC;MACrD,aAAa;EACjB;;EAEA;MACI,eAAe,EAAE,qBAAqB;EAC1C;;EAEA;;MAEI,eAAe,EAAE,qBAAqB;EAC1C;;EAEA;MACI,sBAAsB,EAAE,kCAAkC;MAC1D,uBAAuB;EAC3B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');\r\n@import url(\"https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap\");\r\n\r\n/* General Container Styling */\r\n.faculty-detail1 {\r\n  padding: 20px;\r\n  background-color: #f9f9f9; /* Light gray for readability */\r\n  color: #ffffff; /* Darker text for contrast */\r\n  font-family: 'Raleway', sans-serif;\r\n  margin: 0 auto; /* Center the content */\r\n  max-width: 1200px; /* Width restriction */\r\n  font-size: 0;\r\n\r\n}\r\n\r\n/* Header Section */\r\n.faculty-detail header {\r\n  background-image: linear-gradient(rgb(17, 17, 240), rgba(100, 127, 49, 0.35)), url('./images/Directory.png');\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end; /* Aligns content to bottom */\r\n  text-align: end; /* Right-aligned text */\r\n  \r\n  background-size: cover; /* Covers the area */\r\n  background-position: center; /* Centers the background image */\r\n  height: 400px; /* Adjust height for visibility */\r\n  padding: 10px;\r\n \r\n  color: #844a4a; /* White text color */\r\n}\r\n\r\n/* Faculty Profile Container */\r\n.faculty-profile-container2 {\r\n  display: flex;\r\n  gap: 1px; /* Space between left and right columns */\r\n  margin-top: 20px; /* Separation from header */\r\n  border: 0;\r\n  border-color: #999baa;\r\n  align-items: flex-start; /* Top alignment for content */\r\n}\r\n\r\n/* Left Column Styling */\r\n.brief-details1 {\r\n  flex: 1; /* Left column width */\r\n  background-color: #1b070700; /* White background for contrast */\r\n  padding: 10px;\r\n  border: 0px solid #ddd; /* Subtle border */\r\n  border-radius: 3px; /* Rounded corners */\r\n  box-shadow: 0 5px 7px rgba(255, 255, 255, 0.1); /* Shadow effect */\r\n}\r\n\r\n/* Image Styling */\r\n.faculty-image1 {\r\n  width: 190px;\r\n  height: 190px;\r\n  object-fit: cover; /* Maintain aspect ratio */\r\n  border-radius: 50%; /* Circular shape */\r\n  border: 0px solid #007bff; /* Blue border */\r\n  margin-right: 20px; /* Space beside the image */\r\n}\r\n\r\n/* Text and Titles */\r\n.faculty-name1 {\r\n  font-size: 19px; /* Slightly larger for emphasis */\r\n  font-family: 'Raleway', sans-serif;\r\n  \r\n  font-weight: bold; /* Bold for prominence */\r\n  color: #211c4a; /* Darker text */\r\n  \r\n}\r\n\r\n.faculty-designation1,\r\n.faculty-department1 {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-size: 13px; /* Font size for roles and departments */\r\n  color: #4b2a2a; /* Subtle gray */\r\n  margin: 0px 0; /* Space between text */\r\n}\r\n\r\n/* Bottom Section in Left Column */\r\n.brief-bottom1 {\r\n  margin-top: 25px; /* Space above the bottom section */\r\n}\r\n\r\n/* Contact Info */\r\n.contact-info1 {\r\n  display: flex; /* Align icon and text */\r\n  align-items: center; /* Center vertically */\r\n  font-family: 'Raleway', sans-serif;\r\n  margin: 10px 0; /* Space between items */\r\n  padding: 10px 0px; /* Inner spacing */\r\n  font-size: 16px; /* Base font size */\r\n  color: #4a4a4a; /* Default text color */\r\n}\r\n\r\n.contact-info1 i {\r\n  margin-right: 10px; /* Space between icon and text */\r\n  \r\n  font-size: 18px; /* Icon size */\r\n  color: #007bff; /* Icon color */\r\n}\r\n\r\n.contact-info1 .contact-text1 {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-size: 14px; /* Text font size */\r\n  line-height: 0; /* Line spacing */\r\n  color: #432020; /* Text color */\r\n}\r\n\r\n.contact-info1 .contact-text1 strong {\r\n  font-family: 'Raleway', sans-serif;\r\n  color: #583a3a; /* Bold text color */\r\n  font-size: 13px; /* Text font size */\r\n\r\n  font-weight: bold; /* Ensure boldness */\r\n}\r\n.contact-text1 a:hover {\r\n  text-decoration: underline; /* Underline on hover */\r\n}\r\n\r\n/* Links for Profiles */\r\n.profile-links1 {\r\n  margin-top: 10px; /* Space above the links */\r\n}\r\n\r\n.profile-links1 a {\r\n  color: #007bff; /* Blue for links */\r\n  font-size: 14px; /* Font size */\r\n  font-family: 'Raleway', sans-serif;\r\n  text-decoration: none; /* No underline */\r\n}\r\n\r\n.profile-links1 a:hover {\r\n  text-decoration: underline; /* Underline on hover */\r\n}\r\n\r\n/* Right Column Styling */\r\n.details-section1 {\r\n\r\n  flex: 2; /* Right column takes more space */\r\n  background-color: #e2e6ea; /* Subtle gray background */\r\n  padding: 20px;\r\n  border: 0px solid #ddd; /* Subtle border */\r\n  border-radius: 1px; /* Rounded corners */\r\n}\r\n\r\n/* Updated Text Elements in Right Column */\r\n.details-section1 p {\r\n  margin: 10px 0; /* Vertical spacing */\r\n  font-size: 15px; /* General font size */\r\n  font-weight: 100px;\r\n  font-family: 'Raleway', sans-serif;\r\n  line-height: 1.4; /* Line spacing for readability */\r\n  color: #142535; /* Slightly darker text */\r\n  white-space: pre-wrap; /* Preserve spaces and line breaks */\r\n}\r\n\r\n/* Heading Styling */\r\n.details-section1 h3 {\r\n  font-weight: bold;\r\n  font-size: 14px; /* Larger font for headings */\r\n  font-family: 'Raleway', sans-serif;\r\n  color:#163046; /* Blue headings */\r\n  margin-bottom: 10px; /* Space below headings */\r\n}\r\n\r\n/* Horizontal Line Styling */\r\n.details-section1 hr {\r\n  border: 0;\r\n  height: 1px;\r\n  background-color: #fbfbfb; /* Light gray line */\r\n  margin: 15px 0; /* Space around lines */\r\n}\r\n\r\n.publication-item {\r\n  display: flex;\r\n  font-size: 14px; /* Larger font for headings */\r\n  font-family: 'Raleway', sans-serif;\r\n  color:#071a29; /* Blue headings */\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  \r\n  padding: 5px;\r\n}\r\n\r\n\r\n/* Responsive Adjustments */\r\n@media screen and (max-width: 768px) {\r\n  .faculty-profile-container2 {\r\n      flex-direction: column; /* Stack columns vertically */\r\n  }\r\n\r\n  .brief-details1,\r\n  .details-section1 {\r\n      max-width: 100%; /* Full width for smaller screens */\r\n      flex: unset; /* Remove flex properties */\r\n  }\r\n\r\n  .faculty-image {\r\n      margin-right: 0; /* Remove space for smaller screens */\r\n      margin-bottom: 15px; /* Add spacing below */\r\n  }\r\n}\r\n\r\n/* Additional Small Screen Adjustments */\r\n@media screen and (max-width: 480px) {\r\n  .faculty-image {\r\n      width: 120px; /* Reduce size for very small screens */\r\n      height: 120px;\r\n  }\r\n\r\n  .faculty-name1 {\r\n      font-size: 18px; /* Adjust font size */\r\n  }\r\n\r\n  .faculty-designation1,\r\n  .faculty-department1 {\r\n      font-size: 14px; /* Adjust font size */\r\n  }\r\n\r\n  .contact-info1 {\r\n      flex-direction: column; /* Stack contact info vertically */\r\n      align-items: flex-start;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
